import React from "react";
import { Link } from "react-router-dom";

import style from "./style";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
} from "@material-ui/core";
import { OutlinedButton } from "../../components/Buttons";

//Importing assets
import MailIcon from "../../assets/social-icons/mail.svg";
import LocationIcon from "../../assets/social-icons/map-pin.svg";
import GithubLogo from "../../assets/social-icons/github.svg";
import LinkedInLogo from "../../assets/social-icons/linkedin.svg";
import InstagramLogo from "../../assets/social-icons/instagram.svg";
import CodepenLogo from "../../assets/social-icons/Codepen.svg";
import BehanceLogo from "../../assets/social-icons/Behance.svg";
import Twitter from "../../assets/social-icons/twitter.svg";

const useStyles = makeStyles(style);
function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.footerBackground}>
      <div className={classes.footerBackground__main}>
        <Typography
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
          data-aos="fade-in" data-aos-duration="100"
        >
          Let's get in touch.
        </Typography>
        <div className={classes.footerColumn}>
          <div>
            <Typography data-aos="fade-in" data-aos-duration="200" variant="h6" gutterBottom className={classes.footer_desc}>
              My inbox is always open, Whether you have a question or just want to
              say hi. I’ll try my best to get back to you!
            </Typography>
            <Link to={`/contact`} className="hover-detect">
              <OutlinedButton data-aos="fade-in" data-aos-duration="300" size="large">Contact Me</OutlinedButton>
            </Link>


          </div>
          <div className={classes.contactLinksContainer}>
            <span className="hover-detect">
            <a href="mailto:devrajchatribin9978@gmail.com?subject=Contact | Portfolio" target="_blank" rel="noreferrer" className={classes.contactLinks}>
              <Typography data-aos="fade-in" data-aos-duration="400" variant="h6" className={classes.footer_desc} >devrajchatribin9978@gmail.com</Typography>
              <img src={MailIcon} data-aos="fade-in" data-aos-duration="300" alt="Email ID" />
            </a>
            </span>
            <span className="hover-detect">
            <a href="https://goo.gl/maps/tGnq9Q1KV7Ex1fXi7" target="_blank" rel="noreferrer" className={classes.contactLinks}>
              <Typography data-aos="fade-in" data-aos-duration="500" variant="h6" className={classes.footer_desc} >Panaji-Goa, India.</Typography>
              <img src={LocationIcon} alt="Location" data-aos="fade-in" data-aos-duration="400" />
            </a>
            </span>
          </div>
        </div>



        <hr width="100%" color="#63718A" style={{ opacity: "0.2" }}></hr>

        <div className={classes.footer_end}>
          <Typography
            variant="subtitle2"
            style={{ color: "#8EA2C7" }}
            className={classes.footer_author}
            
          >
            © 2022 All rights reserved. 
            <span style={{ color: "#b6cfff", margin: "0 0 0 0.3rem" }}>
              {" "}
              Devraj Chatribin.
            </span>
          </Typography>

          <div className="social_icons_footer">
            <a href="https://github.com/DevrajDC" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="300" data-aos-anchor-placement="bottom-bottom" src={GithubLogo} alt="Github" />
            </a>

            <a href="https://linkedin.com/in/devraj-chatribin" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="400" data-aos-anchor-placement="bottom-bottom" src={LinkedInLogo} alt="LinkedIn" />
            </a>

            <a href="https://instagram.com/designfordev" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="500" data-aos-anchor-placement="bottom-bottom" src={InstagramLogo} alt="Instgram" />
            </a>

            <a href="https://twitter.com/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="600" data-aos-anchor-placement="bottom-bottom" src={Twitter} alt="Twitter" />
            </a>

            <a href="https://codepen.io/devrajdc/" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="700" data-aos-anchor-placement="bottom-bottom" src={CodepenLogo} alt="Codepen" />
            </a>

            <a href="https://www.behance.net/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
              <img data-aos="zoom-in" data-aos-delay="800" data-aos-anchor-placement="bottom-bottom" src={BehanceLogo} alt="Behance" />
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Footer;
